import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
import SearchBox from "../../../components/SearchBox";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { getPropertyByKey } from "../../../utils/getPropertyByKey";
import api from "../../../api/axios";
import ReturnAssetModal from "../../../components/modelpopup/ReturnAssetModal";

const EmployeeAssetsDetail = ({
  selectedEmployeeDetail,
  setShowAssetDetail,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [assetId, setAssetId] = useState(null);
  const [assetModalLoading, setAssetModalLoading] = useState(true);
  const [assetData, setAssetData] = useState({});
  const [assetStatus, setAssetStatus] = useState([]);
  const [assetType, setAssetType] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [isReturnModalVisible, setIsReturnModalVisible] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);

  const employeeId = localStorage.getItem("employeeID");

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    // setEmployId('');
  };

  useEffect(() => {
    fetchAssetStatus();
    fetchAssetType();
  }, []);

  const fetchAssetStatus = () => {
    api
      .get(`assets-status`)
      .then((res) => {
        setAssetStatus(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchAssetType = () => {
    api
      .get(`asset-types`)
      .then((res) => {
        setAssetType(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const columns = [
    {
      title: "Asset",
      dataIndex: "asset_type",
      key: "asset_type",
      render: (text) => text,
    },
    {
      title: "Manufacturer",
      dataIndex: "manufacturer",
      key: "manufacturer",
      render: (text) => text,
    },
    {
      title: "Serial number",
      dataIndex: "serial_number",
      key: "serial_number",
      render: (text) => text,
    },
    {
      title: "Assigned_date",
      dataIndex: "assigned_date",
      key: "assigned_date",
      render: (text) => {
        if (text) {
          return text.split("T")[0];
        } else {
          return "-";
        }
      },
    },
    {
      title: "Policy acknowledged",
      dataIndex: "policy_acknowledged",
      key: "policy_acknowledged",
      render: (text) => (text == 1 ? "Yes" : "No"),
    },
    {
      title: "Employee received",
      dataIndex: "employee_received",
      key: "employee_received",
      render: (text) => (text == 1 ? "Yes" : "No"),
    },
    {
      title: "Return date",
      dataIndex: "return_date",
      key: "return_date",
      render: (text) => {
        if (text) {
          return text.split("T")[0];
        } else {
          return "-";
        }
      },
    },
    {
      title: "Return received",
      dataIndex: "return_received",
      key: "return_received",
      render: (text, record) =>
        !record.return_date ? "-" : text == 1 ? "Yes" : "No",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => getPropertyByKey(assetStatus, "id", text, "name"),
    },
    {
      title: "Action",
      render: (text, record) => (
        <div className="action-menu text-end">
          <div className="d-flex gap-2 mt-2">
            <Button
              disabled={record.return_received}
              className="bg-transparent border-0 dropdown-item"
              onClick={(e) => {
                e.preventDefault();
                showReturnModal(record);
                setAssetId(record.id);
              }}
            >
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip
                    id="tooltip-view"
                    style={{ fontSize: "12px", padding: "2px" }}
                  >
                    {record.return_received
                      ? "Asset Returned"
                      : "Take Asset Return"}
                  </Tooltip>
                }
              >
                <i
                  className={`fa fa-undo m-r-5 ${
                    record.return_received ? "text-secondary" : "text-primary"
                  }`}
                />
              </OverlayTrigger>
            </Button>
          </div>
        </div>
      ),
    },
  ];

  const showReturnModal = (asset) => {
    setSelectedAsset(asset);
    setIsReturnModalVisible(true);
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <div className="table-responsive">
            <div className="d-flex justify-content-between">
              <div className="flex-grow-1">
                <SearchBox setPaginationValue={setPageSize} />
              </div>
            </div>
            <Table
              className="table-striped"
              columns={columns}
              dataSource={selectedEmployeeDetail}
              rowKey={(record) => record.id}
              loading={loading}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: selectedEmployeeDetail.length,
                showSizeChanger: true,
                onChange: handlePageChange,
                pageSizeOptions: ["5", "10", "15"],
              }}
            />
          </div>
        </div>
      </div>
      <ReturnAssetModal
        isVisible={isReturnModalVisible}
        onClose={() => setIsReturnModalVisible(false)}
        asset={selectedAsset}
        employeeId={employeeId}
        onAssetReturned={() => window.location.reload()}
      />
    </div>
  );
};

export default EmployeeAssetsDetail;
